'use client';

export const RAIL_ITEM_ACTIVE_CLASS = 'bg-accent text-accent-foreground';

/**
 * Surface for every rail hover popup, so they read as the same panel black as the global filters
 * popover (`bg-background`) rather than each picking their own dark tone.
 */
export const RAIL_TOOLTIP_SURFACE_CLASS = 'border-border bg-background';

/**
 * Every rail popup opens the same 4px past the rail's right edge, matching the project switcher
 * and the global filters popover. Triggers that span the rail need only that gap; the 32px icon
 * buttons sit ~12px short of the edge, so they add it back.
 */
export const RAIL_POPUP_SIDE_OFFSET = 4;
export const RAIL_ICON_POPUP_SIDE_OFFSET = 16;

export const RAIL_ICON_BUTTON_INTERACTIVE_CLASS =
  'border-[rgba(140,147,217,0.52)] bg-[rgba(140,147,217,0.24)] text-[rgb(143,184,238)]';

export const RAIL_CENTER_LABELED_BUTTON_CLASS =
  'group flex w-full flex-col items-center gap-0.5 rounded-md py-1.5 disabled:pointer-events-none disabled:opacity-50';

export const RAIL_CENTER_ICON_BUTTON_CLASS =
  'relative flex h-7 w-[34px] items-center justify-center rounded-lg border border-transparent text-[rgba(161,161,170,1)] transition-colors group-hover:border-[rgba(140,147,217,0.52)] group-hover:bg-[rgba(140,147,217,0.24)] group-hover:text-[rgb(143,184,238)]';

export const RAIL_CENTER_ICON_BUTTON_ACTIVE_CLASS = RAIL_ICON_BUTTON_INTERACTIVE_CLASS;

export const RAIL_BOTTOM_ICON_BUTTON_BASE_CLASS =
  'relative flex size-8 items-center justify-center rounded-lg border border-transparent text-[rgba(161,161,170,1)] transition-colors disabled:pointer-events-none disabled:opacity-50';

export const RAIL_BOTTOM_ICON_BUTTON_CLASS = `${RAIL_BOTTOM_ICON_BUTTON_BASE_CLASS} hover:border-[rgba(140,147,217,0.52)] hover:bg-[rgba(140,147,217,0.24)] hover:text-[rgb(143,184,238)]`;

export const RAIL_BOTTOM_ICON_BUTTON_ACTIVE_CLASS = RAIL_ICON_BUTTON_INTERACTIVE_CLASS;

export const RAIL_CENTER_LABEL_CLASS =
  'max-w-full truncate text-center text-[9px] leading-tight tracking-[-0.2px] text-zinc-400';

export const RAIL_CENTER_LABEL_ACTIVE_CLASS = 'text-white';

export const RAIL_CENTER_ICON_CLASS = 'h-[18px] w-[18px]';

export const RAIL_CENTER_LABELED_BUTTON_DISABLED_CLASS =
  'opacity-50 group-hover:[&>span:first-child]:border-transparent group-hover:[&>span:first-child]:bg-transparent group-hover:[&>span:first-child]:text-[rgba(161,161,170,1)]';

export function useRailActiveStyles(isActive: boolean, isDisabled = false, allowActiveWhenDisabled = false) {
  return {
    isActive: isActive && (!isDisabled || allowActiveWhenDisabled),
  };
}
